require('./brokerMyInvestmentsContracts.scss');
const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const Immutable = require('immutable');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const BrokerMyInvestmentsWrappedContractsTable = require('../brokerMyInvestmentsWrappedContractsTable/brokerMyInvestmentsWrappedContractsTable');
const BrokerMyInvestmentsWrappedStockContractTable = require('../brokerMyInvestmentsWrappedContractsTable/brokerMyInvestmentsWrappedStockContractTable/brokerMyInvestmentsWrappedStockContractTable');
const BrokerMyInvestmentsWrappedFundsContractTable = require('../brokerMyInvestmentsWrappedContractsTable/brokerMyInvestmentsWrappedFundsContractTable/brokerMyInvestmentsWrappedFundsContractTable');
const BrokerMyInvestmentsFundsTable = require('components/broker/myInvestments/brokerMyInvestmentsFundsTable/brokerMyInvestmentsFundsTable');
const BrokerMyInvestmentsFooter = require('../brokerMyInvestmentsFooter/brokerMyInvestmentsFooter');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @constants
const {
    TYPE_STOCKS,
    TYPE_FUNDS,
    TYPE_PLANS,
    EURO_TEXT,
    MYPROFILE_BROKER_EXPLORE,
    BROKER_CONTRACT_VALUE_TYPE,
    BROKER_CONTRACT_FUND_TYPE,
    BROKER_CONTRACT_PLAN_TYPE
} = require('constants/index');
const { buildContactCenterContractsList } = require('utilities/contactCenter/brokerMyInvestmentsContractsHelper')

class BrokerMyInvestmentsContracts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompleteList: {}
        };

        this.wrapProductTable = this.wrapProductTable.bind(this);
        this.buildPlansTable = this.buildPlansTable.bind(this);
        this.handleSeeAllLinkClick = this.handleSeeAllLinkClick.bind(this);
    }

    componentDidMount() {
        if (__CONTACT_CENTER__) {
            const {
                getStocksByContract,
                getContractState,
                immStocksContracts
            } = this.props
            getStocksByContract()
            getContractState(immStocksContracts)
        }
    }

    getCurrency() {
        const { immStocksByType } = this.props;
        let currency = EURO_TEXT;

        // `findEntry` can return either `undefined` or an array with the following format: [key, value]
        // In this case, because of the condition, value will be a Map that will have a truthy currency field.
        const entry = immStocksByType.findEntry(val => val && val.get('currency'));
        if (entry) {
            currency = entry[1].get('currency');
        }

        return currency;
    }

    wrapProductTable(immContract, type, accountNumber) {
        const { onOpenTraderClick, postWalletAlias, immMyWalletCharts, immStocksByType, setOperationContractValue, setOrdersAndMovementsContract, onInternalTransferFundsClick, immBrokerContractState } = this.props;
        const immProducts = immContract.get('elements');

        if (!immContract) {
            return null;
        }

        if(immProducts.size > 0) {
            if (type === TYPE_STOCKS) {
                return (
                    <BrokerMyInvestmentsWrappedStockContractTable
                        immContract={immContract}
                        immBrokerContractState={immBrokerContractState}
                        accountNumber={accountNumber}
                        immMyWalletCharts={immMyWalletCharts}
                        postWalletAlias={postWalletAlias}
                        setOrdersAndMovementsContract={setOrdersAndMovementsContract}
                        setOperationContractValue={setOperationContractValue}
                        onOpenTraderClick={onOpenTraderClick}
                        type={type}
                        showCompleteList={this.state.showCompleteList}
                        onHandleSeeAllLinkClick={this.handleSeeAllLinkClick}
                        onHandleBuyClick={this.props.onHandleBuyClick}
                        pageName={this.props.pageName}
                    >
                    </BrokerMyInvestmentsWrappedStockContractTable>
                );

            } else if (type === TYPE_FUNDS) {
                return (
                    <BrokerMyInvestmentsWrappedFundsContractTable
                        immContract={immContract}
                        immStocksByType={immStocksByType}
                        accountNumber={accountNumber}
                        postWalletAlias={postWalletAlias}
                        setOrdersAndMovementsContract={setOrdersAndMovementsContract}
                        onInternalTransferFundsClick={onInternalTransferFundsClick}
                        type={type}
                        pageName={this.props.pageName}
                        immFundsContributionsList={this.props.immFundsContributionsList}
                    >
                    </BrokerMyInvestmentsWrappedFundsContractTable>
                );
            }
        }
    }

    buildShowPlansTable(immProduct, contractId) {
        return (
            <BrokerMyInvestmentsFundsTable
                type={TYPE_PLANS}
                immStocks={[immProduct]}
                showCompleteList={this.state.showCompleteList[contractId]}
                isContractSection={true}
            />
        );
    }

    getProductFromContract(immProducts, immContract) {
        return immProducts.find((immProduct) => {
            const productContractNumber = immProduct.get('numerodecontrato');
            const productContractProduct = immProduct.get('product');

            const contractNumber = immContract.get('numerodecontrato');
            const contractProduct = immContract.get('producto');

            return (
                productContractNumber == contractNumber &&
                contractProduct == productContractProduct
            );
        });
    }

    buildPlansTable() {
        const { immStocksByType, immStocksContracts, pageName } = this.props;
        const immPlanContracts = immStocksContracts.filter(
            (immContract) => immContract.get('tipoContrato') === BROKER_CONTRACT_PLAN_TYPE
        );
        const products = immStocksByType.getIn(['plans', 'stocks']);
        const plansSize = immPlanContracts.size;

        let result = [];
        let showTable;
        immPlanContracts.forEach((immContract) => {
            const contractId = immContract.get('contract');
            const earnings = immContract.get('summarizedProfitability');
            const totalValue = immContract.get('summarizedValor');
            const earningsPercentage = immContract.get('profitablePercentage');
            const capital = immContract.get('investmentsCapital');
            const contractName = immContract.get('descripcion');

            immContract.get('elements').forEach((immElement) => {
                const immProduct = this.getProductFromContract(products, immElement);
                showTable = this.buildShowPlansTable(immProduct, contractId);
                if (immElement && immElement.get('alias', '')) {
                    result.push(
                        <BrokerMyInvestmentsWrappedContractsTable
                            contractName={contractName}
                            earnings={earnings}
                            earningsPercentage={earningsPercentage}
                            capital={capital}
                            total={totalValue}
                            currency={immElement.get('totalValueCurrency')}
                            size={plansSize}
                            accountNumber={contractId}
                            contractId={contractId}
                            type={TYPE_PLANS}
                            contract={immElement}
                            postAlias={this.props.postWalletAlias}
                            interventionType={immElement.get('interventionType')}
                            contractForTooltip={immElement.get('contractForTooltip')}
                            setOrdersAndMovementsContract={this.props.setOrdersAndMovementsContract}
                            key={contractId}
                            pageName={pageName}
                        >
                            {showTable}
                            <div className="broker-my-investments-tables__link-wrapper clearfix">
                                <div className="pull-left broker-my-investments-tables__link">
                                    <OKLink to={MYPROFILE_BROKER_EXPLORE} >
                                        {formatText(`broker-searchByContractLinkPension`)}
                                    </OKLink>
                                </div>
                            </div>
                        </BrokerMyInvestmentsWrappedContractsTable>
                    );
                }
            });
        });

        return result;
    }

    handleSeeAllLinkClick(contractId) {
        this.setState(function (prevState) {
            return {
                showCompleteList: Object.assign({}, prevState.showCompleteList, {
                    [contractId]: true
                })
            };
        });
    }

    buildContactCenterContractsTable(accountsContracts, immStocksByType) {
        let contracts = [];
        accountsContracts.forEach((immContract) => {

            const contractType = immContract.get('tipoContrato');
            const contractId = immContract.get('contract');
            const earnings = immContract.get('summarizedProfitability');
            const totalValue = immContract.get('summarizedValor');
            const earningsPercentage = immContract.get('profitablePercentage');
            const capital = immContract.get('investmentsCapital');
            const contractName = immContract.get('descripcion');

            switch (contractType) {
                case BROKER_CONTRACT_VALUE_TYPE:
                    contracts.push(this.wrapProductTable(immContract, TYPE_STOCKS, contractId));
                    break;
                case BROKER_CONTRACT_FUND_TYPE:
                    contracts.push(this.wrapProductTable(immContract, TYPE_FUNDS, contractId));
                    break;
                case BROKER_CONTRACT_PLAN_TYPE:
                    immContract.get('elements').forEach((immElement) => {
                        const products = immStocksByType.getIn(['plans', 'stocks']);
                        const immProduct = this.getProductFromContract(products, immElement);
                        const plansTable = this.buildShowPlansTable(immProduct, contractId);
                        if (immElement && immElement.get('alias', '')) {
                            contracts.push(
                                <BrokerMyInvestmentsWrappedContractsTable
                                    contractName={contractName}
                                    earnings={earnings}
                                    earningsPercentage={earningsPercentage}
                                    capital={capital}
                                    total={totalValue}
                                    currency={immElement.get('totalValueCurrency')}
                                    accountNumber={contractId}
                                    contractId={contractId}
                                    type={TYPE_PLANS}
                                    contract={immElement}
                                    postAlias={this.props.postWalletAlias}
                                    interventionType={immElement.get('interventionType')}
                                    contractForTooltip={immElement.get('contractForTooltip')}
                                    setOrdersAndMovementsContract={this.props.setOrdersAndMovementsContract}
                                    key={contractId}
                                    pageName={this.props.pageName}
                                >
                                    {plansTable}
                                    <div className="my-investments-tables__link-wrapper clearfix">
                                        <div className="pull-left my-investments-tables__link">
                                            <OKLink to={MYPROFILE_BROKER_EXPLORE} >
                                                {formatText(`broker-searchByContractLinkPension`)}
                                            </OKLink>
                                        </div>
                                    </div>
                                </BrokerMyInvestmentsWrappedContractsTable>
                            );
                        }
                    });
                    break;
            }
        });
        return contracts;
    }

    hasProducts(contractsByAccount) {
        let hasProducts = false
        contractsByAccount.forEach((contract) => {
            if(contract.get('elements').size > 0) hasProducts = true;
        })

        return hasProducts;
    }


    buildContractsGroupedByAccount(contractsGroupedByAccount, immStocksByType) {
        let content;
        const accountsNameIban = contractsGroupedByAccount.keySeq().toArray();

        content = accountsNameIban.map((accountName) => {
            const contractsTable = this.buildContactCenterContractsTable(contractsGroupedByAccount.get(accountName), immStocksByType);
            const hasElements = this.hasProducts(contractsGroupedByAccount.get(accountName));
            return (
                <div key={accountName}>
                    <WebappRender>
                        <p className="my-investments-tables__account-name">{accountName}</p>
                    </WebappRender>
                    <ContactCenterRender>
                        {hasElements && <p className="my-investments-tables__account-name">{accountName}</p>}
                    </ContactCenterRender>
                    <section>
                        {contractsTable}
                    </section>
                </div>
            )
        });

        return content;
    }

    render() {
        const {
            immAccounts,
            immStocksContracts,
            immStocksByType,
            isFetchingStocksByContract,
            displayStocks,
            displayFunds,
            displayPlans,
            totalInvestment,
            totalEarnings,
            totalEarningsPercentage,
            totalValue,
            displayFooter,
            immMyWalletCharts
        } = this.props;

        const currency = this.getCurrency();
        const contractTypesToShow = [
            displayStocks ? BROKER_CONTRACT_VALUE_TYPE : '',
            displayFunds ? BROKER_CONTRACT_FUND_TYPE : '',
            displayPlans ? BROKER_CONTRACT_PLAN_TYPE : ''
        ];
        const contractsGroupedByAccount = __CONTACT_CENTER__ ? buildContactCenterContractsList(immStocksContracts, immAccounts, contractTypesToShow) : {};
        const contactCenterContractsGroupedByAccount = __CONTACT_CENTER__ ? this.buildContractsGroupedByAccount(contractsGroupedByAccount, immStocksByType) : null;

        let stockTables, fundsTable, plansTable, footer;
        
        if (!__CONTACT_CENTER__ && displayStocks) {
            stockTables = immStocksContracts.filter((immContract) => {
                const tipoContrato = immContract.get('tipoContrato');
                return (tipoContrato ? tipoContrato == BROKER_CONTRACT_VALUE_TYPE : false);
            }).map((immContract) => {
                const contract = immContract.get('contract');
                return this.wrapProductTable(immContract, TYPE_STOCKS, contract);
            })
            .toList();
        }

        if (!__CONTACT_CENTER__ && displayFunds) {
            fundsTable = immStocksContracts.filter((immContract) => {
                const tipoContrato = immContract.get('tipoContrato');
                return (tipoContrato ? tipoContrato == BROKER_CONTRACT_FUND_TYPE : false);
            }).map((immContract) => {
                const contract = immContract.get('contract');
                return this.wrapProductTable(immContract, TYPE_FUNDS, contract);
            }).toList();
        }

        if (!__CONTACT_CENTER__ && displayPlans) {
            plansTable = this.buildPlansTable();
        }

        if (displayFooter) {
            footer = (
                <BrokerMyInvestmentsFooter
                    isContractFooter={true}
                    currency={currency}
                    totalCapital={totalInvestment}
                    totalRentability={totalEarnings}
                    totalRentabilityPercentage={totalEarningsPercentage}
                    totalValue={totalValue}
                    immMyWalletCharts={immMyWalletCharts}
                />
            );
        }

        if (isFetchingStocksByContract) {
            return <LoadingSection />;
        } else {
            return (
                <div>
                    <div className="broker-my-investments-tables">
                        {contactCenterContractsGroupedByAccount}
                        {stockTables}
                        {fundsTable}
                        {plansTable}
                        {footer}
                    </div>
                </div>
            );
        }
    }
}

BrokerMyInvestmentsContracts.propTypes = {
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    setOperationContractValue: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object,
    immStocksByContract: PropTypes.object,
    immStocksByType: PropTypes.object.isRequired,
    getStocksByContract: PropTypes.func,
    isFetchingStocksByContract: PropTypes.bool,
    postWalletAlias: PropTypes.func.isRequired,
    displayStocks: PropTypes.bool,
    displayFunds: PropTypes.bool,
    displayPlans: PropTypes.bool,
    totalInvestment: PropTypes.number,
    totalEarnings: PropTypes.number,
    totalEarningsPercentage: PropTypes.number,
    totalValue: PropTypes.number,
    displayFooter: PropTypes.bool,
    onInternalTransferFundsClick: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    immMyWalletCharts: PropTypes.object,
    getContractState: PropTypes.func,
    immBrokerContractState: PropTypes.object,
    onHandleBuyClick: PropTypes.func,
    pageName: PropTypes.func
};

BrokerMyInvestmentsContracts.defaultProps = {
    immStocksContracts: Immutable.Map(),
    displayStocks: true,
    displayFunds: true,
    displayPlans: true,
    displayFooter: true
};

module.exports = BrokerMyInvestmentsContracts;
